import { Link, useLocation } from "react-router-dom";
import Logo from "../../icons/logo";
import { useTranslation } from "react-i18next";
import ChangeLang from "./changeLanguage";
import MessagePopup from "../popups/messagePopup";
import { useState } from "react";
import UserIcon from "../../icons/userIcon";

const Header = () => {
  const { t } = useTranslation();
  // deleted
  const [login, setLogin] = useState(false);
  const UserType = (
    <>
      <h2 className="my-5 text-2xl font-bold text-center text-mainRed">
        {t("loginAs")}
      </h2>
      <div className="flex justify-between gap-4">
        <Link
          className="flex w-full h-[80px] justify-center hover:opacity-70 items-center gap-2 text-lg font-bold border border-mainBlue text-mainBlue px-3 py-2 rounded-[10px]"
          to={"/employee/dashboard"}
        >
          <UserIcon fill={"#0051ff"} />
          {t("employee")}
        </Link>
        <Link
          className="flex w-full h-[80px] justify-center hover:opacity-70 items-center gap-2 text-lg font-bold border border-mainBlue text-mainBlue px-3 py-2 rounded-[10px]"
          to={"/agent/dashboard"}
        >
          <UserIcon fill={"#0051ff"} />
          {t("agent")}
        </Link>
      </div>
    </>
  );
  //
  const { pathname } = useLocation();
  return (
    <header className="py-4 bg-white">
      <div className="flex items-center justify-between w-11/12 mx-auto">
        <div>
          <Logo />
        </div>
        <nav className="flex items-center gap-4 font-medium lg:text-lg text-capitalize">
          <Link
            className={`${pathname === "/" ? "text-mainBlue" : "text-black"}`}
            to="/"
          >
            {t("home")}
          </Link>
          <Link
            className={`${
              pathname.startsWith("/services") ? "text-mainBlue" : "text-black"
            }`}
            to="/services"
          >
            {t("services")}
          </Link>
          <Link
            className={`${
              pathname.startsWith("/offer-price") ? "text-mainBlue" : "text-black"
            }`}
            to="/offer-price"
          >
            {t("offerPrice")}
          </Link>
          <Link
            className={`${
              pathname.startsWith("/tools") ? "text-mainBlue" : "text-black"
            }`}
            to="/tools"
          >
            {t("tools")}
          </Link>
          <Link
            className={`${
              pathname.startsWith("/blogs") ? "text-mainBlue" : "text-black"
            }`}
            to="/blogs"
          >
            {t("blogs")}
          </Link>
          <Link
            className={`${
              pathname.startsWith("/about-Us") ? "text-mainBlue" : "text-black"
            }`}
            to="/about-Us"
          >
            {t("aboutUs")}
          </Link>
          <Link
            className={`${
              pathname.startsWith("/bloog") ? "text-mainBlue" : "text-black"
            }`}
            to="bloog"
          >
            {t("blog")}
          </Link>
        </nav>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setLogin(true)}
            className="block text-mainGray hover:underline pulse px-3 py-2 rounded-[10px]"
          >
            {t("login")}
          </button>
          {/* <button className="text-mainGray hover:underline">{t("login")}</button> */}
          <Link
            to={"/auth"}
            className="bg-mainBlue block text-white rounded-[10px] hover:bg-mainBlue/90 px-3 py-2 "
          >
            {t("signUp")}
          </Link>

          <div className="z-50">
            <ChangeLang />
          </div>
        </div>
        {/* deleted */}
        <MessagePopup
          noTimer
          setState={setLogin}
          state={login}
          text={UserType}
          containerClassName={" w-[50%] h-[400px]"}
        />
        {/*  */}
      </div>
    </header>
  );
};

export default Header;
